import { useQuery } from '@tanstack/react-query';

import { listPointsPurchaseOffersAdmin } from '~/services/LuxLoyalty';

import { pointsPurchaseQueryKeys } from './pointsPurchaseQueryKeys';

export function useGetPointsPurchaseOffers(currency?: string) {
  return useQuery({
    queryKey: pointsPurchaseQueryKeys.offersByCurrency(currency ?? 'all'),
    queryFn: async ({ signal }) => listPointsPurchaseOffersAdmin({ currency }, { signal }),
  });
}
